import React, { useEffect, useState } from "react";
import { Stepper, FormGenerator } from "../../../../components";
import { Box, Button, Grid, Typography, Divider } from "@mui/material";
import { LeadStylesParent } from "./style";
import {
  useWindowDimensions,
  enumSelect,
  enum_types,
  NetWorkCallMethods,
  AlertProps,
  convertTimeUtcToZoneCalander,
  LocalStorageKeys,
  SemiBold,
  concat_string
} from "../../../../utils";
import { loadOptions } from "../../../../utils/asyncPaginateLoadOptions";
import { GET_ACTIVITY_CATAGORY_MASTER } from "../../../../graphql/queries";
import { config } from "../../../../config";
import { NetworkCall } from "../../../../networkcall";
import { AlertContext, AuthContext } from "../../../../contexts";
import { MapSource } from "./commom";
import moment from "moment";

export const AddActivity = (props) => {
  const { t } = (props)
  // classes
  const classes = LeadStylesParent(props);
  const alert = React.useContext(AlertContext);
  const company = JSON.parse(localStorage.getItem(LocalStorageKeys.selectedCompany))
  const [disable, setDisable] = useState(false);

  // state

  const [enumValue, setEnumValue] = useState({
    priority: [],
    purpose: [],
    followUp: [],
  });

  const size = useWindowDimensions();

  const steps = [
    {
      label: t("Activity Details"),
      step: 1,
      value: props?.step,
    },
    {
      label: t("Preview and Submit"),
      step: 2,
      value: props?.step,
    },
  ];

  const getEnum = async () => {
    const result = await enumSelect([
      enum_types?.purpose_global_type,
      enum_types?.urgent_type,
      enum_types?.follow_up_type,
    ]);
    setEnumValue({
      priority: result?.urgent_type ?? [],
      purpose: result?.purpose_global_type ?? [],
      followUp: result?.follow_up_type,
    });
  };
  const save = () => {
    setDisable(true)
    const activity = {
      activity_category: props?.state?.Category?.value,
      notes: props?.state?.Notes,
      priority: props?.state?.Priority,
      email_id: props?.state?.email ?? undefined,
      type:
        props?.state?.Followup?.value?.length > 0
          ? props?.state?.Followup?.value
          : undefined,
      proxy_lead_id: props?.proxy_lead_id ?? undefined,
      phone_number: props?.state?.mobile?.mobile ?? undefined,
      location: props?.state?.location ?? undefined,
      date_time: props?.state?.visitorDate ?? undefined,
      phone_code: props?.state?.mobile?.mobile_code ?? undefined,
      // purpose: props?.state?.Purpose?.value,
      lead_activity_master: props?.type?.id,
      activity_sub_category: props?.state?.subcatagory?.value ?? undefined,
      company_id: company?.value ?? undefined,
      // activity_sub_category:props?.state?.subcatagory?.value ?? undefined,
      calendar_event_params: {
        subject: "PropGOTO - "
          + concat_string(
            {
              category_name: props?.state?.Category?.label,
              reference_name: props?.proxy_lead_data?.name,
              reference_no: props?.proxy_lead_data?.reference_no,
            },
            ["category_name", "reference_name", "reference_no"],
            ", "
          )
          + (props?.state?.Priority?.length > 0 ? ` - (${props?.state?.Priority?.charAt(0).toUpperCase()}${props?.state?.Priority?.slice(1)})` : ``),
        notes: props?.state?.Notes?.length > 0 ? props?.state?.Notes : "",
        start: {
          dateTime: moment(props?.state?.visitorDate).format("YYYY-MM-DDTHH:mm:ss"),
          timeZone: company?.timezone?.length > 0 ? company.timezone : "UTC",
        },
        end: {
          dateTime: moment(props?.state?.visitorDate).add(30, "m").format("YYYY-MM-DDTHH:mm:ss"),
          timeZone: company?.timezone?.length > 0 ? company.timezone : "UTC",
        },
      },
    };

    if (props?.state?.isEdit) {
      activity["id"] = props?.state?.id;
      activity["updated_by"] = localStorage.getItem("profileID");
    } else {
      activity["created_by"] = localStorage.getItem("profileID");
      activity["status"] = "Open";
    }
    NetworkCall(
      `${config.api_url}/lead_proxy/activity`,
      NetWorkCallMethods.post,
      {
        activity,
      },
      null,
      true,
      false
    )
      .then((response) => {
        setDisable(false)
        props?.cancel();
        props?.getActivityList(0, 10);
        alert.setSnack({
          ...alert,
          open: true,
          severity: AlertProps.severity.success,
          msg: `Lead ${props?.data?.isEdit === true ? t("Updated") : t("Created")
            } successfully.`,
        });
        props?.reset()
      })
      .catch((error) => {
        setDisable(false)
        alert.setSnack({
          ...alert,
          open: true,
          severity: AlertProps.severity.error,
          msg: t("Internal error. Please try again later."),
        });
      });
  };

  useEffect(() => {
    getEnum();
  }, []);

  const components = {
    1: (
      <Step1
        state={props?.state}
        enumValue={enumValue}
        updateState={props?.updateState}
        type={props?.type}
        t={t}
      />
    ),
    2: <Step2 t={t} type={props?.type} state={props?.state} />,
  };

  return (
    <div>
      <div
        style={{
          height: size?.height - 300,
          textAlign: "left",
          overflow: "auto",
        }}
      >
        <Stepper t={t} step={props?.step} steps={steps} type={props?.type} padding={"6px 16px"} />
        {components[props?.step]}
      </div>
      <Box className={classes.bottomButton}>
        <Box>
          <Button
            className={classes.cancel}
            onClick={props?.previous}
            disabled={props?.step <= 1 ? true : false}
          >
            {t("previous")}
          </Button>
          {props?.step === 2 ? (
            <Button className={classes.next} onClick={save} disabled={disable}>
              {props?.state?.isEdit ? t("Update") : t("Submit")}
            </Button>
          ) : (
            <Button className={classes.next} onClick={props?.next}>
              {t("Next")}
            </Button>
          )}
        </Box>
      </Box>
    </div>
  );
};

const Step1 = (props) => {
  const { t } = (props)

  const clientID = localStorage.getItem(LocalStorageKeys.clinetID) ?? undefined
  const company = JSON.parse(localStorage.getItem(LocalStorageKeys.selectedCompany))
  return (
    <div style={{ padding: "16px" }}>
      <FormGenerator t={t}
        spacing={2}
        components={[
          {
            isActive: true,
            component: "select",
            label: t("Category"),
            value: props?.state?.Category,
            placeholder: t("Category"),
            onChange: (value) => props?.updateState("Category", value),
            error: props?.state?.error?.Category,
            isRequired: true,
            size: {
              xs: 12,
              sm: 12,
              md: 6,
              lg: 6,
            },
            isPaginate: true,
            fontFamily: SemiBold,
            loadOptions: (search, array, handleLoading) =>
              loadOptions(
                search,
                array,
                handleLoading,
                GET_ACTIVITY_CATAGORY_MASTER,
                "activity_category_master",
                { isActive: true, client: clientID, company: company?.value },
                { label: "label", value: "value" },
                false,
                false,
                props?.type?.id,
              ),
            menuOptionHeight: "150px"
          },
          // {
          //   isActive: true,
          //   component: "select",
          //   label: "Sub Category",
          //   value: props?.state?.subcatagory,
          //   placeholder: "sub Catagory",
          //   onChange: (value) => props?.updateState("subcatagory", value),
          //   error: props?.state?.error?.subcatagory,
          //   isRequired: true,
          //   size: {
          //     xs: 12,
          //     sm: 12,
          //     md: 6,
          //     lg: 6,
          //   },
          //   isPaginate: true,
          //   loadOptions: (search, array, handleLoading) =>
          //     loadOptions(
          //       search,
          //       array,
          //       handleLoading,
          //       GET_ACTIVITY_SUB_CATAGORY_MASTER,
          //       "activity_sub_category_master",
          //       { isActive: true },
          //       { label: "label", value: "value" },
          //       false,
          //       false,
          //       props?.state?.subcatagory?.value
          //     ),
          //   key: JSON.stringify(props?.state?.Category),
          // },
          // {
          //   isActive: true,
          //   component: "select",
          //   label: "Purpose",
          //   value: props?.state?.Purpose,
          //   placeholder: "Purpose",
          //   onChange: (value) => props?.updateState("Purpose", value),
          //   error: props?.state?.error?.Purpose,
          //   isRequired: true,
          //   size: {
          //     xs: 12,
          //     sm: 12,
          //     md: 6,
          //     lg: 6,
          //   },
          //   options: props?.enumValue?.purpose ?? [],
          // },
          {
            isActive: props?.type?.name === "Phone call" ? true : false,
            component: "mobile",
            label: t("Phone Number"),
            value: props?.state?.mobile,
            placeholder: t("Phone Number"),
            onChange: (value) => props?.updateState("mobile", value),
            error: props?.state?.error?.mobile,
            isRequired: true,
            size: {
              xs: 12,
              sm: 12,
              md: 6,
              lg: 6,
            },
          },
          {
            isActive:
              props?.type?.name === "Follow up" ||
                props?.type?.name === "Meeting" ||
                props?.type?.name === "Appointment"
                ? true
                : false,
            component: "select",
            label: t("Followup Type"),
            value: props?.state?.Followup,
            placeholder: t("Followup"),
            onChange: (value) => props?.updateState("Followup", value),
            error: props?.state?.error?.Followup,
            isRequired: true,
            size: {
              xs: 12,
              sm: 12,
              md: 6,
              lg: 6,
            },
            options: props?.enumValue?.followUp ?? [],
          },
          {
            isActive:
              props?.state?.Followup?.value === "In-Person" ? true : false,
            component: "text",
            label: t("Location"),
            value: props?.state?.location,
            placeholder: t("Location"),
            onChange: (value) =>
              props?.updateState("location", value?.target?.value),
            error: props?.state?.error?.location,
            isRequired: true,
            size: {
              xs: 12,
              sm: 12,
              md: 6,
              lg: 6,
            },
          },
          {
            isActive:
              props?.type?.name === "Send Email" ||
                props?.type?.name === "Send Quotation"
                ? true
                : false,
            component: "text",
            label: t("Email"),
            value: props?.state?.email,
            placeholder: t("Email"),
            onChange: (value) =>
              props?.updateState("email", value?.target?.value),
            error: props?.state?.error?.email,
            isRequired: true,
            size: {
              xs: 12,
              sm: 12,
              md: 6,
              lg: 6,
            },
          },
          {
            isActive: true,
            component: "datePickerWithTime",
            label: t("Call Date & Time"),
            value: props?.state?.visitorDate,
            placeholder: t("Select Visit Date & Time"),
            onChange: (value) => props?.updateState("visitorDate", value),
            error: props?.state?.error?.visitorDate,
            minDate: new Date(),
            isRequired: true,
            is_popover: true,
            margin: "11px 0px 0px 12px",
            size: {
              xs: 12,
              sm: 12,
              md: 6,
              lg: 6,
            },
          },
          // {
          //   isActive: true,
          //   component: "newDatePickerAutoTime",
          //   label: "Call Date & Time",
          //   value: props?.state?.visitorDate,
          //   placeholder: "Select Visit Date & Time",
          //   onChange: (value) => props?.updateState("visitorDate", value),
          //   error: props?.state?.error?.visitorDate,
          //   minDate: new Date(),
          //   isRequired: true,
          //   margin:"11px 0px 0px 12px",
          //   size: {
          //     xs: 12,
          //     sm: 12,
          //     md: 6,
          //     lg: 6,
          //   },
          // },
          {
            size: {
              xs: 12,
              sm: 6,
              md: 6,
              lg: 6,
            },
            isActive: true,
            component: "toggle",
            label: t("Priority"),
            value: props?.state?.Priority,
            placeholder: t("Priority"),
            onChange: (value) => props?.updateState("Priority", value),
            error: props?.state?.error?.Priority,
            isRequired: true,
            options: props?.enumValue?.priority ?? [],
          },
          {
            isActive: true,
            component: "text",
            label: t("Notes"),
            value: props?.state?.Notes,
            placeholder: t("Notes"),
            onChange: (value) =>
              props?.updateState("Notes", value?.target?.value),
            error: props?.state?.error?.Notes,
            isRequired: true,
            multiline: true,
            size: {
              xs: 12,
              sm: 12,
              md: 12,
              lg: 12,
            },
          },
        ]}
      />
    </div>
  );
};

const Step2 = (props) => {
  const { t } = (props)
  // classes
  const previewType = MapSource[props?.type?.name];
  const classes = LeadStylesParent();

  const auth = React.useContext(AuthContext)
  return (
    <div style={{ padding: "16px" }}>
      <Box
        className={classes.typeCard}
        style={{ backgroundImage: `url(${previewType?.background})` }}
      >
        <img src={previewType?.image} alt={previewType?.text} />
        <Typography className={classes.typeName}>
          {previewType?.text}
        </Typography>
      </Box>

      <Box className={classes.flexBox}>
        <Box  className={classes.flexBox1}>
          <Typography className={classes.title}>{t("CATEGORY")}</Typography>
          <Typography className={classes.sub}>
            {props?.state?.Category?.label}
          </Typography>
        </Box>
        {
          !!props?.state?.visitorDate && <Box className={classes.flexBox1}>
            <Typography className={classes.title}>CALL DATE & TIME</Typography>
            <Typography className={classes.sub}>
              &#x202a;{moment(props?.state?.visitorDate).format("DD MMM YY h:mm a")}&#x202c;

            </Typography>
          </Box>
        }
        {/* <Box className={classes.flexBox1}>
          <Typography className={classes.title}>PURPOSE</Typography>
          <Typography className={classes.sub}>
            {props?.state?.Purpose?.value}
          </Typography>
        </Box> */}
        {props?.state?.visitorDate?.length > 0 && (
          <Box className={classes.flexBox1}>
            <Typography className={classes.title}>{t("START DATE")}</Typography>
            <Typography className={classes.sub}>
              {convertTimeUtcToZoneCalander(props?.state?.visitorDate)}
            </Typography>
          </Box>
        )}
        {props?.state?.mobile?.mobile_code?.length > 0 && (
          <Box className={classes.flexBox1}>
            <Typography className={classes.title}>{t("PHONE NUMBER")}</Typography>
            <Typography className={classes.sub}>
              {props?.state?.mobile?.mobile_code} -{" "}
              {props?.state?.mobile?.mobile}
            </Typography>
          </Box>
        )}
        {props?.state?.email?.length > 0 && (
          <Box className={classes.flexBox1}>
            <Typography className={classes.title}>{t("EMAIL ID")}</Typography>
            <Typography className={classes.sub}>
              {props?.state?.email}
            </Typography>
          </Box>
        )}
        {props?.state?.location?.length > 0 && (
          <Box className={classes.flexBox1}>
            <Typography className={classes.title}>{t("LOCATION")}</Typography>
            <Typography className={classes.sub}>
              {props?.state?.location}
            </Typography>
          </Box>
        )}
        {props?.state?.Followup?.length > 0 && (
          <Box className={classes.flexBox1}>
            <Typography className={classes.title}>{t("FOLLOW UP")}</Typography>
            <Typography className={classes.sub}>
              {props?.state?.Followup}
            </Typography>
          </Box>
        )}

        <Box className={classes.flexBox1}>
          <Typography className={classes.title}>{t("PRIORITY")}</Typography>
          <Typography className={classes.sub}>
            {props?.state?.Priority}
          </Typography>
        </Box>
      </Box>
      <Box className={classes.margin}>
        <Divider />
      </Box>
      <Grid container spacing={2}>
        <Grid item xs={12}>
          <Typography className={auth?.auth?.auth?.language === 'ar' ? classes.titleRtl : classes.title}>{t("NOTE")}</Typography>
          {/* <ShowMoreText
            lines={2}
            more="Show More"
            less="Show Less"
            className={classes.sub}
            anchorClass={classes.seeMoreLessTextStyle}
            expanded={false}
            truncatedEndingComponent={"... "}
          > */}
          <Typography sx={{ textAlign: auth?.auth?.auth?.language === 'ar' ? "-webkit-right" : "left" }} className={classes.sub}>
            {(props?.state?.Notes && props?.state?.Notes?.length > 0) && (props?.state?.Notes?.split('\n').map((item, i) => <div key={i}>{item}</div>))}

            {/* {props?.state?.Notes ?? ""} */}
          </Typography>
          {/* </ShowMoreText> */}
        </Grid >
      </Grid >
    </div >
  );
};
